<template>
	<div class="exchanges">
		<Tou></Tou>
		<!-- <div class="w1500 bj-0 p-50 mt-50 mb-60 t-center exchanges1">
			<i class="el-icon-check f-50 B-700 ys-0 p-15" style="background: linear-gradient(0deg,#ff775b 0%, #e80b17 100%, #2989cc 100%);border-radius: 50%;"></i>
			<div class="tit-20 mt-34">Congratulations,You have successfully exchanged Amazon Gift Card $20!</div>
			<div class="tit-20 mb-30 mt-16" style="color: #666666;">voucher: <span style="color: #E60012;">2gb47hhf</span></div>
			<div class="tit-16 line-24 w48 " style="color: #666666;margin: 0 auto;">
				<i class="iconfont icon-zhuyi"></i>
				Successfully redeemed! You can find this order in my order, and we will shipit for you as soon as possible.Thank you for your understanding
			</div>
			<div class="w25 flex a-center j-between" style="margin: .65rem auto;">
				<div class="hangan hangan1 cur_pointer ys-0">My order</div>
				<div class="hangan hangan2 cur_pointer">Close</div>
			</div>
		</div> -->
		<div class="w1500 bj-0  mt-50 mb-60 exchanges1">
			<div class="m-50" v-if="yy!='PK'">
				<div class="montserRegular tit-30 biaotie flex a-center pt-50"> <span class="mr-20 "></span> Please select your shipping address</div>
				<div class="mt-75 pb-30" style="border: 1px solid #f2f2f2;" >
					<div class="br-33 montserRegular pt-20 pb-20 pl-47 ys-0 tit-20 mb-40" style="background: linear-gradient(87deg,#ff785c 0%, #e70a16 100%);margin-top: -35px;">Shipping information</div>
					<el-radio-group v-model="addressid" class="w100 radioChes">
						<el-radio :label="l.id" v-for="(l,i) in address">
							<div style="flex: 1;" class="text">{{l.country}}{{l.province}}{{l.region}}{{l.city}}{{l.detailAddress}}</div>
							<div class="w40 conrols">
								<span class="w50 inline-block montserRegular">Default Address</span>
								<span class="w50 inline-block" style="color: #E80E18; text-align: center;">Modify</span>
							</div>
						</el-radio>
						<!-- <el-radio :label="2">Solarland Bayern GmbH Zeppelinstr. 11 85748 Garching  </el-radio>
						<el-radio :label="3">Solarland Bayern GmbH Zeppelinstr. 11 85748 Garching  </el-radio>
						<el-radio :label="4">Solarland Bayern GmbH Zeppelinstr. 11 85748 Garching  </el-radio> -->
					</el-radio-group>
				</div>
			</div>
			<div  class="m-50 pb-30" v-else-if="yy=='PK'">
				<el-form class="adddressform pt-50" label-position="top" label-width="80px" :model="hkplusshu">
					<el-form-item label="Name">
						<el-input class="inputs input1" v-model="hkplusshu.name"></el-input>
					</el-form-item>
					<el-form-item label="Name of Bank">
						<el-input class="input2"  v-model="hkplusshu.bankName"></el-input>
					</el-form-item>
					<el-form-item label="Bank Account Title">
						<el-input class="inputs input1" v-model="hkplusshu.bankAccountTitle"></el-input>
					</el-form-item>
					<el-form-item label="IBAN Number">
						<el-input class="inputs input1" v-model="hkplusshu.ibanNumber"></el-input>
					</el-form-item>
					<el-form-item label="Mobile Number">
						<el-input class="input2"  v-model="hkplusshu.mobile"></el-input>
					</el-form-item>
					<el-form-item label="Company Name (Installer/EPC)">
						<el-input class="inputs input1" v-model="hkplusshu.companyName"></el-input>
					</el-form-item>
					<el-form-item label="Address">
						<el-input class="inputs input1" v-model="hkplusshu.address"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="w100 t-center mt-40 mb-60 " v-if="yy!='PK'">
				<div @click="$router.push({name:'address'})" class="tit-16 ys-0 anniu inline-block cur_pointer" style="background: linear-gradient(-26deg,#e70a16 0%, #ff785c 100%);border-radius: 25px;">Add shipping address</div>
			</div>
			<div class="montserRegular tit-30 biaotie flex a-center m-50"> <span class="mr-20"></span> Order detail</div>
			<div class="flex p-33 m-50 j-between jinfenbox" style=" background: #f6f6f8; border-radius: 10px; align-items: center;">
				<div class="flex">
					<el-image class="imgs" fit="fill" :src="infos.image" alt="" v-if="infos.image" />
					<div class="ml-50 mt-10">
						<div class="tit-20 mb-20">{{infos.commodityName}}</div>
						<div class="montserRegular tit-18" style="color: #E80E18;">{{infos.needIntegral}}points</div>
					</div>
				</div>
				<div class="flex">
					 <el-input-number v-model="hkplusshu.quantity" @change="jiajian" :min="1" :max="10" label="描述文字"></el-input-number>
				</div>
			</div>
			<div class="m-50" style="font-size: 12px;color:#333;padding: 10px;">Orders before 20th issued by the end of each month, orders after 20th issued next month. If you have any questions, please contact <span style="color:red;">hassam.aziz@goodwe.com</span>.</div>
			<div class="w100 t-center mt-40 mb-60 pb-50" >
				<div @click="Duihuan" class="tit-16 ys-0 anniu inline-block cur_pointer" style="background: linear-gradient(-26deg,#e70a16 0%, #ff785c 100%);border-radius: 25px;">Redeem now</div>
			</div>
		</div>
		
		
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {addresslist,spxiangqin,swpduihuan,pkswpduihuan} from '@/api/PointsMall.js';
	export default {
		data() {
			return {
				addressid: 0,
				max: '',
				mail: {},
				infos:{title:'',needIntegral:''},
				address:[],
				sid:'',
				yy:'',
				yiti:'',
				hkplusshu:{
					name:'',
					bankName:'',
					bankAccountTitle:'',
					ibanNumber:'',
					mobile:'',
					companyName:'',
					address:'',
					quantity:0
				}
			}
		},
		components: {
			Tou,
			Foot,
		},
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
				this.yy=this.$store.state.yuyan
				// console.log(this.gudingziduan,'video')
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created() {
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.yy=this.$store.state.yuyan
			// this.sid = this.$route.query.id;
			this.sid = this.$route.params.id;
			spxiangqin({id:this.sid}).then(shu=>{
				if(shu.code!=200){
					this.$message({
					  showClose: true,
					  iconClass:'el-icon-warning',
					  customClass:'my-error-message',
					  message: shu.message,
					  type: 'error',
					  offset:'350',
					  duration:0
					});
				}
				this.infos=shu.data
			})

			addresslist({name:''}).then(shu=>{

				
				if(shu.data.length>=1){
					this.address=shu.data
				}else{
					this.address=[]
				}
			})
			
		},
		methods: {
			// 提交兑换\
			jiajian(e){
				
			},
			Duihuan(){
				if(this.yy=='PK'){
					var dsshu={}
					dsshu=this.hkplusshu
					dsshu.commodityId=this.sid
					pkswpduihuan(dsshu).then(s=>{
						if(s.code>200){
							this.$message({
							  showClose: true,
							  iconClass:'el-icon-warning',
							  customClass:'my-error-message',
							  message: s.message,
							  type: 'error',
							  offset:'350',
							  duration:0
							});
						}else{
							this.$message({
							  showClose: true,
							  message: 'success',
							  type: 'success',
							  offset:'350',
							  duration:0
							});
							// this.$dakai('/results?id=' + s.data+'&type=3')
							this.$router.push({name: "results",params:{id:s.data,type:3}})
						}
					})
				}else{
					swpduihuan({id:this.sid,addressId:this.addressid}).then(s=>{
						if(s.code>200){
							this.$message({
							  showClose: true,
							  iconClass:'el-icon-warning',
							  customClass:'my-error-message',
							  message: s.message,
							  type: 'error',
							  offset:'350',
							  duration:0
							});
						}else{
							this.$message({
							  showClose: true,
							  message: s.message,
							  type: 'success',
							  offset:'350',
							  duration:0
							});
							// this.$dakai('/results?id=' + s.data+'&type=3')
							this.$router.push({name: "results",params:{id:s.data,type:3}})
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.exchanges{
		.biaotie span {display: inline-block;width: .08rem;height: .28rem;background: #e60012;border-radius: 4px;}
		::v-deep .el-radio__input.is-checked .el-radio__inner{
			border-color: #E60012;
			background: #ffffff;
		}
		::v-deep .el-radio {display: block;margin: 0 .25rem;}
		::v-deep .el-radio__inner{width: .24rem;height: .24rem;border-width: 2px;}
		::v-deep .el-radio__inner::after {background-color: #E60012;width: .12rem;height: .12rem;}
		::v-deep .el-radio__label,.el-radio__input.is-checked+.el-radio__label {color: #666666;}
		::v-deep .el-radio {padding: .24rem;display: flex;}
		::v-deep .is-checked { background: #f7f7f7; border-radius: 10px;  }
		::v-deep .el-radio__label {display: flex;flex: 1;}
		.imgs {width: 2.46rem; height: 1.59rem; border-radius: 10px;}
		.anniu {padding: .12rem .22rem; border-radius: 100px;}
		.hangan {padding: .12rem .22rem;border-radius: 100px;}
		.hangan1 { background: linear-gradient(-26deg,#e70a16 0%, #ff785c 100%);}
		.hangan2 { background: #F6F6F8;}
	}

	.exchanges ::v-deep .el-radio__label {flex-wrap: wrap;}
	.radioChes ::v-deep .el-radio__input {display: inline-flex; align-items: center;}
	.radioChes .text {white-space: wrap; word-wrap: break-word; margin-right: .3rem;}


// ==========================================================================================================================================================================
// 响应式
@media screen and (max-width: 767px) {
	.radioChes .text {margin-right: 0;}
	.radioChes .conrols {width: 100%; margin-top: .2rem;}
	.radioChes ::v-deep .el-radio__input {margin-top: .1rem; align-items: flex-start;}
	.jinfenbox{
		display: block !important;
	}
}
	
</style>